import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { dateRangeFormGroup } from "../booking-search-form/config";
import { FieldValue, IPatchTypeConfig } from "app_sasha/shared/models/SearchUtils";
import { IDateRange } from "libraries/service/resources/model/search/IDateRange";
import * as moment from "moment";
import { IAfidiumServicePatchedValue } from "app_sasha/shared/models/search-utils.service";

@Injectable()
export class AfidiumServiceFieldsetService {

  constructor(
      private fb: FormBuilder,
  ) {}

  public addService(form: FormGroup):void {
    const newField: FormArray = form.controls.afidiumServices as FormArray;
    newField.push(this.fb.group({
      serviceCodes: [[]],
      eligibilityStatuses: [[]],
      operationStatuses: [[]],
      whenExecutedOperation: dateRangeFormGroup(this.fb),
    }));
  }

  public patchAfidiumServiceValue (fieldValue: FieldValue, config: IPatchTypeConfig,formArrayIndexNumber:number) : IAfidiumServicePatchedValue {

    let serviceCodes: string[] = [];
    let eligibilityStatuses: string[] = [];
    let operationStatuses: string[] = [];
    let whenExecutedOperation: {} = {};
    Object.keys(fieldValue[formArrayIndexNumber]).forEach((afidiumServiceFieldName: string) => {
      if(config.array && config.array.includes(afidiumServiceFieldName)){
        const fieldValueArray: string[] = fieldValue[formArrayIndexNumber][afidiumServiceFieldName] as string[];
        if (afidiumServiceFieldName === "serviceCodes"){
          serviceCodes = fieldValueArray;
        } else if (afidiumServiceFieldName === "eligibilityStatuses"){
          eligibilityStatuses = fieldValueArray;
        } else if (afidiumServiceFieldName === "operationStatuses"){
          operationStatuses = fieldValueArray;
        }
      }
      if (config.date && config.date.includes(afidiumServiceFieldName)) {
        const serviceDate: IDateRange = fieldValue[formArrayIndexNumber][afidiumServiceFieldName] as IDateRange;
        whenExecutedOperation = {
          min: serviceDate && serviceDate.min
              ? moment(serviceDate.min).toDate()
              : null,
          max: serviceDate && serviceDate.max
              ? moment(serviceDate.max).toDate()
              : null,
        };
      }
    });
    return {
      operationStatuses,
      whenExecutedOperation,
      serviceCodes,
      eligibilityStatuses
    };

  }
}
